<template>
  <span class="badge">
    <span class="text" :style="{ borderBottom: `1px solid ${color}` }">
      <ellipsis :length="40" tooltip>{{ text }}</ellipsis>
    </span>
  </span>
</template>

<script>
export default {
  name: '',
  props: {
    color: {
      type: String,
      default: '#fff',
    },
    text: {
      type: String,
      default: 'text',
    },
  },
};
</script>

<style lang="less" scoped>
.badge {
  flex: none;
  display: flex;
  align-items: center;
  margin: 8px;
  .dot {
    flex: none;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin: 0 8px;
  }
}
</style>
